
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/employee-helpdesk-capabilities",
      function () {
        return require("private-next-pages/employee-helpdesk-capabilities.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/employee-helpdesk-capabilities"])
      });
    }
  